import {Stock} from '../models/stock/stock.model';
import {JobStock} from '../models/stock/jobStock.model';

export namespace Stocks {
  export class GetStocks {
    static readonly type = '[Stock api] GetStocks';

    constructor(public force: boolean = false) {
    }
  }

  export class GetStock {
    static readonly type = '[Stocks api] GetStock';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateStock {
    static readonly type = '[Stocks api] CreateStock';

    constructor(public stock: Stock) {
    }
  }

  export class UpdateStock {
    static readonly type = '[Stocks api] Update Stock';

    constructor(public stock: Stock) {
    }
  }

  export class DeleteStock {
    static readonly type = '[Stocks api] Delete Stock';

    constructor(public stock: Stock) {
    }
  }

  export class GetJobStock {
    static readonly type = '[Stocks api] GetJobStock';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobStock {
    static readonly type = '[Stocks api] UpdateJobStock';

    constructor(public jobStock: JobStock) {
    }
  }

  export class UpdateJobStockLocal {
    static readonly type = '[Stocks local] UpdateJobStock';

    constructor(public jobStock: JobStock) {
    }
  }
}
